export default {
    'multiple-languages': {
        title: 'Version 2.3: Keybreak spricht sieben Sprachen',
        excerpt: 'Version 2.3 bringt Mehrsprachigkeit, die gesamte App und die Website sind jetzt in sieben Sprachen verfügbar, weitere folgen.',
    },
    'micro-breaks': {
        title: 'Version 2.2: Mikropausen',
        excerpt: 'Nach einigem Nutzerfeedback ergänzt Version 2.2 Mikropausen: alle 10–15 Minuten ein kleiner Hinweis in der Ecke deines Bildschirms mit einer Sache, die du ausprobieren kannst.',
    },
    'dynamic-hold-system': {
        title: 'Version 2.1: Klügere Haltezeiten und besseres Feedback',
        excerpt: 'Version 2.1 bringt zwei Dinge: eine Möglichkeit, die Haltezeit spontan zu verlängern, und ein neues Animationssystem, das dir genau zeigt, wo du in jedem Halten gerade bist.',
    },
    'science-of-sitting': {
        title: 'Die Wissenschaft des Sitzens: Was die Forschung darüber sagt, den ganzen Tag zu sitzen',
        excerpt: 'Sitzendes Verhalten ist ein eigenständiges Gesundheitsrisiko, weitgehend unabhängig davon, ob du Sport treibst. Das zeigt die Forschung tatsächlich.',
    },
    'benefits-of-moving': {
        title: 'Warum mehr Bewegung im Arbeitsalltag wirklich zählt',
        excerpt: 'Regelmäßige Bewegungspausen helfen nicht nur deinem Körper. Sie machen dich wacher, weniger müde und im Lauf des Tages produktiver.',
    },
    'keybreak-launch': {
        title: 'Keybreak: Dein smarter Begleiter für Pausen',
        excerpt: 'Nach Monaten der Entwicklung freuen wir uns riesig, dass Keybreak offiziell verfügbar ist, kostenlos zum Herunterladen für Mac und Windows.',
    },
}
